import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { NavController } from '@ionic/angular';
import { StorageService } from 'src/app/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GuardLoginGuard implements CanActivate {
  constructor(
    private storageSv: StorageService,
    private navCtrl: NavController
  ){}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(async () =>{
        const isLogined = await this.storageSv.get('userInfo');
        if(!isLogined){
          resolve(!isLogined);
        }else{
          this.navCtrl.navigateForward('home/dashboard');
          resolve(false);
        }
      })
    })
  }
  
}
